import { Routes } from '@angular/router';
import { LandingComponent } from './presentations/landing/landing.component';
import { ErrorComponent } from './presentations/error/error.component';
import { InvoiceClaimVoucherComponent } from './presentations/invoice-claim-voucher/invoice-claim-voucher.component';
import { RoamingComponent } from '@presentation/roaming/roaming.component';
import { SetScheduleComponent } from '@presentation/roaming/pages/set-schedule/set-schedule.component';
import { CheckoutComponent } from '@presentation/roaming/pages/checkout/checkout.component';

// routes di buat lazy load agar tidak membebani aplikasi (load saat diakses) (use loadComponent)
export const routes: Routes = [
    {
        path: 'roaming',
        component: RoamingComponent,
        children: [
            {
                path: 'set-schedule/:type/:mlid', // ROAMING TYPE : btl or store
                component: SetScheduleComponent
            },
            {
                path: 'checkout/:mlid',
                component: CheckoutComponent
            }
        ]
    },
    {
        path: '404',
        component: ErrorComponent
    },
    {
        path: 'invoice-claim/:status',
        component: InvoiceClaimVoucherComponent
    },
    {
        path: ':content',
        component: LandingComponent
    }
];
